module.exports = __webpack_public_path__ + "static/media/butterfly.2f87b9e3.jpg";